<template>
  <div class="">
    <headerbox></headerbox>

    <div class="main">
      <hotelhead></hotelhead>

      <div class="container">
        <div class="layout">
          <menuTitle :titles="lefttitles"></menuTitle>
          <div class="hotel">
            <ul>  
              <li v-for="(hotelpic, index) in hotelpic" :key="index">
                <img v-lazy="hotelpic.url" :alt="hotelpic.type_name" />
                <h3>{{ hotelpic.type_name }}</h3>
              </li>
            </ul>
          </div>
        </div>

        <div class="sides">
          <menuTitle :titles="righttitles"></menuTitle>
          <leftcheck></leftcheck>
        </div>
      </div>
    </div>
    <footerbox></footerbox>
  </div>
</template>

<script>
import footerbox from "components/content/footer";
import headerbox from "components/content/header";
import hotelhead from "components/content/hotelhead";
import leftcheck from "components/content/Leftcheck";
import menuTitle from "components/content/menuTitle";

import { gethotelpic } from "network/home";
import { setStorage, getStorage } from "@/common/until/until";

export default {
  name: "Gallery",

  components: {
    footerbox,
    headerbox,
    hotelhead,
    leftcheck,
    menuTitle,
  },

  data() {
    return {
      righttitles: "在线酒店查询",
      lefttitles: "酒店照片",
      previousId: null,
      hotelpic: [],
    };
  },

  mounted() {
    this.getHotelpic();
    // this.$bus.$on("decreased", ({ name }) => {
    //
    // });
  },
  updated() {},
  created() {},
  methods: {
    async getHotelpic() {
      const that = this;

      const hid =
        this.$route.query.hid || getStorage("cachedId") || "defaultHid";
      const method = "hotel.info";
      const agent_id = "7596562";
      const agent_md = "cee40804a5b2c83c";

      await this.$nextTick();
      try {
        const res = await gethotelpic({
          hid,
          method,
          agent_id,
          agent_md,
        });
         that.hotelpic = res.reqdata.reqdata.imgs  ;
        const keys = Object.keys(imgs);
       
      } catch (error) {
        // console.error("Error fetching hotel data:", error);
      }
    },
  },
  computed: {},
};
</script>
<style lang="less" scoped>
.hotel ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  li {
    width: 30%;
    margin-bottom: 25px;
    img {
      width: 100%;
      height: 152px;
    }
    h3 {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #180808;
      text-align: center;
      line-height: 42px;
    }
  }
}
@media (min-width: 320px) and (max-width: 780px) {
  .hotel{
    ul {
      flex-wrap: wrap;
      li{
        width: 48%;
      }
    }
  }


 }
</style>





 